import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import SignatureCanvasLib from 'react-signature-canvas';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface SignatureCanvasProps {
  title: string;
  onSignatureChange?: (signature: string) => void;
}

export interface SignatureCanvasRef {
  clear: () => void;
  getSignature: () => string;
  isEmpty: () => boolean;
}

export const SignatureCanvas = forwardRef<SignatureCanvasRef, SignatureCanvasProps>(
  ({ title, onSignatureChange }, ref) => {
    const canvasRef = useRef<SignatureCanvasLib>(null);

    useImperativeHandle(ref, () => ({
      clear: () => {
        canvasRef.current?.clear();
        onSignatureChange?.('');
      },
      getSignature: () => {
        if (canvasRef.current?.isEmpty()) return '';
        return canvasRef.current?.toDataURL() || '';
      },
      isEmpty: () => {
        return canvasRef.current?.isEmpty() || true;
      }
    }));

    const handleSignatureEnd = () => {
      if (!canvasRef.current?.isEmpty()) {
        const signature = canvasRef.current?.toDataURL();
        onSignatureChange?.(signature || '');
      }
    };

    const handleClear = () => {
      canvasRef.current?.clear();
      onSignatureChange?.('');
    };

    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">{title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="border border-border rounded-md overflow-hidden">
            <SignatureCanvasLib
              ref={canvasRef}
              canvasProps={{
                className: 'signature-canvas w-full h-48',
                style: { backgroundColor: 'white' }
              }}
              penColor="black"
              onEnd={handleSignatureEnd}
            />
          </div>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={handleClear}
            className="w-full"
          >
            Limpiar firma
          </Button>
        </CardContent>
      </Card>
    );
  }
);